import React from 'react';

export class MaskInput extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.setMaskValue = this.setMaskValue.bind(this);
        this.applyMask = this.applyMask.bind(this);
        this.state = {
            input: {
                max: props.mask ? props.mask.match(/[0-9]/g).length : undefined,
                value: props.input.value || "",
                pattern: "[0-9]{16}",
                positions: [],
                separators: [],
                notMaskedValue: "",
                selectionStart: 0,
            },
            lastKey: "",
            triggeredBlur: false
        };
    }

    //after the component was mount, the positions of not number characters and their values is determined
    componentDidMount() {
        this.setMaskValue();
        this.applyMask(this.state.input.value);
    }
    componentWillReceiveProps(nextProps) {
        this.setMaskValue();
        let state = Object.assign(this.state);
        this.applyMask(nextProps.input.value);
        this.setState(state);
    }
    //adjust position of input cursor after component was properly re-rendered
    componentDidUpdate() {
        let selectionStart;
        selectionStart = this.state.input.selectionStart;
        if (this.state.input.value.replace(/[^0-9]/g, "").length <= selectionStart && ((this.state.lastKey >= 96 && this.state.lastKey <= 105) || (this.state.lastKey >= 48 && this.state.lastKey <= 57))) {
            selectionStart = this.state.input.value.length;
        }
        document.getElementById(this.props.input.id).setSelectionRange(selectionStart, selectionStart);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return !nextState.triggeredBlur;
    }
    setMaskValue() {
        const regex = new RegExp(/[^0-9]/ig);
        let state = Object.assign(this.state);
        state.input.positions = [];
        state.input.separators = [];
        state.input.max = this.props.mask ? this.props.mask.match(/[0-9]/g).length : undefined;
        if(this.props.mask) {
            while ((regex.exec(this.props.mask)) !== null) {
                state.input.positions.push(regex.lastIndex - 1);
                state.input.separators.push(this.props.mask.charAt(regex.lastIndex - 1));
            }
        }
        this.setState(state);
    }

    //on change of the value, we save the not masked value as well as the masked value and set in the input, only if it didn't reach its limit
    handleChange(e) {

        let state = Object.assign(this.state);
        let val = e.target.value;
        state.input.selectionStart = e.target.value.length;

        if (e.target.selectionStart < e.target.value.length) {
            val = e.target.value.slice(0, state.input.selectionStart - 1) + e.target.value.charAt(state.input.selectionStart) + e.target.value.slice(state.input.selectionStart + 1);
            state.input.selectionStart = e.target.selectionStart;
        }
        if(e.target.selectionStart <= e.target.value.length && e.target.selectionStart <= this.props.mask.length) {
            state.input.value = e.target.value;
            state.input.notMaskedValue = e.target.value;
            this.applyMask(val);
        }

        this.setState(state);
        this.props.onChange(this.state.input.notMaskedValue);
    }

    applyMask(val) {
        let state = Object.assign(this.state);
        state.input.notMaskedValue = val.replace(/[^0-9]/g, "");
        state.input.value = "";
        let value = Object.assign(state.input.notMaskedValue);
        for(let i in state.input.positions) {
            const left = value.slice(0, state.input.positions[i]);
            const sep = value.length > state.input.positions[i] ? state.input.separators[i] : "";
            const right = value.slice(state.input.positions[i]);
            value = left + sep + right;
        }
        state.input.value = value;
        this.setState(state);
    }

    handleBlur(e) {
        this.props.onBlur(this.state.input.notMaskedValue);
        let state = Object.assign(this.state);
        state.triggeredBlur = true;
        this.setState(state);
    }

    handleFocus(e) {
        this.props.onFocus(e);
        let state = Object.assign(this.state);
        state.triggeredBlur = false;
        this.setState(state);
    }

    handleKeyUp(e) {
        let state = Object.assign(this.state);
        state.lastKey = e.keyCode ? e.keyCode : state.lastKey;
        state.input.selectionStart = e.target.selectionStart;
        this.setState(state);
    }

    render() {
        return (
            <input autoFocus={this.props.autoFocus} onFocus={this.handleFocus} id={this.props.input.id} value={this.state.input.value} type="tel" onChange={this.handleChange}
                   onKeyUp={this.handleKeyUp} onBlur={this.handleBlur} required={this.props.input.required}
                   disabled={this.props.input.disabled} placeholder={this.props.input.placeholder}/>
        )
    }
}




// WEBPACK FOOTER //
// ./src/input/base/MaskInput.js